<template>
  <div class="create-synergy-info">
    <div class="header">
      <div class="text">
        <span>协同管理 / </span>
        <span v-if="$route.query.type == 'add'">创建协同</span>
        <span v-if="$route.query.type == 'edit'">编辑协同</span>
        <span v-if="$route.query.type == 'view'">查看协同</span>
      </div>
    </div>
    
      <div class="content">
        <el-scrollbar style="height:100%" class="cooperate-basicForm">
          <el-form ref="basicForm" style="width: 900px" :model="baseForm" label-width="160px" :rules="basicRules">
            <div class="header-info">
              <p></p>
              <h1>创建协同</h1>
            </div>

            <el-form-item label="协同目的：" prop="title">
              <el-input v-if="isAdd || isEdit" size="medium" type="textarea" placeholder="请输入协同目的" v-model.trim="baseForm.title" show-word-limit maxlength="500"></el-input>
              <span v-else>{{ baseForm.title }}</span>
            </el-form-item>

            <el-form-item label="协同类型：" prop="type">
              <el-radio-group v-if="isAdd" v-model="baseForm.type" @change="getComputedPrice()">
                <el-radio label="message">图文协同</el-radio>
                <el-radio label="video">视频协同</el-radio>
              </el-radio-group>
              <span v-else>{{ baseForm.type == "message" ? "图文协同" : "视频协同" }}</span>
            </el-form-item>

            <el-form-item label="协同时间：" prop="startTime">
              <el-date-picker v-if="isAdd || isEdit" size="medium" v-model="baseForm.startTime" type="datetime" style="width: 100%" :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" placeholder="选择时间"> </el-date-picker>
              <span v-else>{{ baseForm.startTime.slice(0, -3) }}</span>
            </el-form-item>

           <!-- 111111 -->
            <el-form-item label="发起医生所属机构：" prop="fromHospitalId">
              <el-select v-if="isAdd" size="medium" v-model="baseForm.fromHospitalId" placeholder="请选择发起医生所属机构" filterable @change="selectFromDoctor">
                <el-option v-for="(item, index) in fromOrgsList" :key="index" :label="item.orgName" :value="item.fromOrgId"> </el-option>
              </el-select>
              <span v-else>{{ baseForm.fromHospitalName }}</span>
            </el-form-item>

            <el-form-item label="发起医生：" prop="fromDoctorId">
              <el-select v-if="isAdd" size="medium" v-model="baseForm.fromDoctorIndex" placeholder="请选择发起医生" filterable @change="getAdmissionList">
                <!-- <el-option v-for="(item, index) in fromDoctorsList" :key="index" :label="item.fromDoctorName" :value="item.fromDoctorId"> </el-option> -->
                <!-- :label="`${item.fromDoctorName} ${item.fromTeamName}`" -->
                <el-option
                  v-for="(item, index) in fromDoctorsList"
                  :key="index"
                  :label="`${item.fromDoctorName}`"
                  :value="index">
                  <span>{{ item.fromDoctorName }}</span>
                  <span style="display:inline-block;margin-left:25px">{{
                    item.fromTeamName
                  }}</span>
                </el-option>
              </el-select>
              <span v-else>{{ baseForm.fromDoctorName }}</span>
            </el-form-item>

            <el-form-item label="发起医生所属团队：" prop="fromDoctorTeamName">
              <span>{{ baseForm.fromDoctorTeamName }}</span>
            </el-form-item>

            <el-form-item label="医生需求：" prop="fromDoctorReqList">
              <el-select v-if="isAdd || isEdit" size="medium" v-model="baseForm.fromDoctorReqList" multiple filterable allow-create default-first-option placeholder="请选择医生需求">
                <el-option v-for="(item, index) in doctorDemandList" :key="index" :label="item" :value="item"> </el-option>
              </el-select>
              <span v-else>{{ baseForm.fromDoctorReq }}</span>
            </el-form-item>

            <el-form-item label="参与医生：" prop="admissionType">
              <el-radio-group v-if="isAdd" v-model="baseForm.admissionType" @change="changeAdmissionType">
                <el-radio label="single">选择医生</el-radio>
                <el-radio label="team">选择团队</el-radio>
              </el-radio-group>
              <span v-else>{{ baseForm.admissionType == 'single' ? "医生" : "团队" }}</span>
            </el-form-item>
            <!-- 参与医生下拉 -->
            <el-form-item v-if="baseForm.admissionType == 'single'" label="" prop="admissionDoctorId">
              <el-select v-if="isAdd" size="medium" v-model="baseForm.admissionDoctorId" placeholder="请选择" filterable @change="changeToDoctors">
                <el-option v-for="(item, index) in toDoctorsList" :key="index" :label="item.doctorName" :value="item.toDoctorId"> </el-option>
              </el-select>
              <span v-else>{{ baseForm.admissionDoctorName }}</span>
            </el-form-item>
            <!-- 参与团队下拉 -->
            <el-form-item v-if="baseForm.admissionType == 'team'" label="" prop="admissionDoctorTeamId">
              <el-select v-if="isAdd" size="medium" v-model="baseForm.admissionDoctorTeamId" placeholder="请选择" filterable @change="changeToTeams">
                <el-option v-for="(item, index) in toTeamsList" :key="index" :label="item.teamName" :value="item.toTeamId"> </el-option>
              </el-select>
              <span v-else>{{ baseForm.admissionDoctorTeamName }}</span>
            </el-form-item>

            <el-form-item label="参与医生所属机构：" prop="admissionHospitalName">
              <span>{{ baseForm.admissionHospitalName }}</span>
            </el-form-item>
            <el-form-item label="问诊患者：" prop="patientId">
              <div style="position:relative">
                <!-- <el-select v-if="isAdd" size="medium" v-model="baseForm.patientId" placeholder="请选择问诊患者" filterable @change="changePatient">
                  <el-option v-for="(item, index) in patientList" :key="index" :label="item.patientName" :value="item.patientId"> </el-option>
                </el-select> -->
                <el-select v-if="isAdd" size="medium" v-model="baseForm.patientId" placeholder="请选择问诊患者" filterable @change="changePatient">
                  <el-option
                    v-for="(item, index) in patientList"
                    :key="index"
                    :label="`${item.patientName}`"
                    :value="item.patientId">
                    <span>{{ item.patientName }}</span>
                    <span style="display:inline-block;margin-left:25px">{{
                      item.patientPhone
                    }}</span>
                  </el-option>
                </el-select>
                <span v-else>{{ baseForm.patientName }}</span>
                <div class="fold-btn">
                  <span v-show="!showStatus" @click="handleFold">展开<i class="el-icon-arrow-down"></i></span>
                  <span v-show="showStatus" @click="handleFold">收起<i class="el-icon-arrow-up"></i></span>
                </div>
              </div>
            </el-form-item>
            <div v-show="showStatus" class="patient-info">
              <el-form-item label="患者当前诊断：" prop="patientChiefComplaint">
                <el-input v-if="isAdd || isEdit" size="medium" type="textarea" style="width:740px" placeholder="请输入患者当前诊断" v-model.trim="baseForm.patientChiefComplaint" show-word-limit maxlength="500"></el-input>
                <span v-else style="word-break:break-all">{{ baseForm.patientChiefComplaint }}</span>
              </el-form-item>
              <el-form-item label="患者病情描述：" prop="patientDiseaseDesc">
                <el-input v-if="isAdd || isEdit" size="medium" type="textarea" style="width:740px" placeholder="请输入患者病情描述" v-model.trim="baseForm.patientDiseaseDesc" show-word-limit maxlength="500"></el-input>
                <span v-else style="word-break:break-all">{{ baseForm.patientDiseaseDesc }}</span>
              </el-form-item>
              <el-form-item :label="`${baseForm.patientName ? baseForm.patientName : ''}检验报告：`" prop="orgCode" class="upload-form-item">
                <div v-if="isAdd || isEdit" style="display:flex;">
                  <!-- <el-upload class="avatar-uploader"
                    action="/api/dsicm-contact-platform/feign/file/upload" :show-file-list="false"
                    :data="{ path: 'patient-medical' }" :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                    <el-button type="primary" size="medium">本地上传</el-button>
                  </el-upload> -->
                  <BaseUploadFile :limit="99" :fileSize="50" :height="36" :size="97.83" :checkMore="true" :multiple="true" :isShowTip="false" :fileType="['png', 'jpg', 'jpeg']" :customUploadBtn="'本地上传'"
                    :beforeRemove="beforeRemovePic" :responseFn="handleIntroChange" :action="VUE_APP_WECHATBASE_URL"
                    :data="{ path:'dsicm-medical', type: 'image', mediaId: '' }" v-model="baseForm.patientMedicalDocs"></BaseUploadFile>
                  <el-button type="primary" :disabled="!baseForm.patientId || baseForm.patientMedicalDocs.length >= 99" size="medium" @click="toQuoteEntry" style="margin-left:10px;height:36px">对照录入引用</el-button>
                </div>
                <ul v-if="baseForm.patientMedicalDocs && baseForm.patientMedicalDocs.length" class="img-list">
                  <li v-for="(item,index) in baseForm.patientMedicalDocs" :key="index">
                    <el-image :preview-src-list="baseForm.patientMedicalDocs" :src="item" alt=""/>
                    <div v-if="isAdd || isEdit" @click="delMedicalImg(index)" class="del-img-btn"><i class="el-icon-close"></i></div>
                  </li>
                </ul>
              </el-form-item>
            </div>
            <el-form-item label="协同价格：" prop="synergyPrice">
              <div v-if="isAdd && editPrice || isEdit && baseForm.status == 'unpay' && editPrice" style="position:relative;width:210px">
                <el-input placeholder="请输入协同价格" size="medium" v-model="baseForm.synergyPrice">
                  <template slot="append">元</template>
                </el-input>
                <el-button class="save-price-btn" type="text" @click="changePrice">保存</el-button>
              </div>
              <span v-else>
                {{ baseForm.synergyPrice }}元
                <el-button v-if="isAdd || (isEdit && baseForm.status == 'unpay')" type="text" @click="changePrice">修改价格</el-button>
              </span>
            </el-form-item>
            <div v-if="isAdd || isEdit" style="text-align: center">
              <el-button size="medium" @click="handleCancel()">取消</el-button>
              <el-button size="medium" @click="resetBasicForm()">重置</el-button>
              <el-button size="medium" type="primary" @click="saveBasicForm()">提交</el-button>
            </div>
            <div v-if="!isAdd && showEditBtn" style="text-align:center">
              <el-button type="primary" @click="editBasicForm()">编辑</el-button>
            </div>
          </el-form>
        </el-scrollbar>
      </div>
    <!-- 查看 -->
    <CrossEntryPicDialog v-if="showLookPic" :showLookPic.sync="showLookPic" 
      :patientId="baseForm.patientId" :patientMedicalDocs="baseForm.patientMedicalDocs" @getQuoteData="getQuoteData"></CrossEntryPicDialog>
  </div>
</template>

<script>
import { synergyStatus,synergyDetail,createSynergy,computedPrice,resetSynergy,updateSynergy, fromOrgs,fromDoctors,toTeams,toDoctors,relationPatients } from "@/api/consultationCooperate";
// import local from "@/utils/local.js";

export default {
  components: {
    CrossEntryPicDialog: () => import("./component/CrossEntryPicDialog.vue")
  },
  props: {},
  data() {
    return {
      VUE_APP_WECHATBASE_URL: '/api/dsicm-contact-platform/feign/file/upload',
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() <= Date.now() - 8.64e7 || time.getTime() > Date.now() + 30 * 24 * 3600 * 1000
        }
      },
      editPrice: false,
      imgPath: process.env.VUE_APP_OSS_URL,
      doctorDemandList: ['希望给到绿通','希望留患者到本院','需求手术指导','询问能否转院'],
      showLookPic: false,
      // otherFolderList: [],
      // selectOtherFile: {},

      showServiceDialog: false,

      baseForm: {
        title: '',
        type: '',
        startTime: '',
        fromHospitalId: '',
        fromDoctorId: '',
        fromDoctorReqList: [],
        admissionType: '',
        admissionDoctorId: '',
        admissionDoctorTeamId: '',
        patientId: '',
        patientChiefComplaint: '',
        patientDiseaseDesc: '',
        synergyPrice: '',
        patientMedicalDocs: [],
        fromDoctorIndex: null
      },
      basicRules: {
        title: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        type: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        startTime: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        fromDoctorId: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        fromDoctorReq: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        admissionType: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        admissionDoctorId: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        admissionDoctorTeamId: [{ required: true, message: "该项为必填项", trigger: "blur" }],

        patientId: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        patientChiefComplaint: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        patientDiseaseDesc: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        fromHospitalId: [{ required: true, message: "该项为必填项", trigger: "blur" }],
        synergyPrice: [
          { required: true, message: "该项为必填项", trigger: "blur" },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '大于等于0，保留两位小数', trigger: ['change', 'blur']}
        ],
        // fromDoctorReqList: [{ required: true, message: "该项为必填项", trigger: "blur" }]
      },
      imgPath: process.env.VUE_APP_OSS_URL,
      channelTypeList: [],
      isAdd: true,
      mainDiseaseList: [],
      showStatus: true,
      fromOrgsList: [],
      fromDoctorsList: [],
      patientList: [],
      toDoctorsList: [],
      toTeamsList: [],
      synergyStatusList: [],
      showEditBtn: false,
      isEdit: false
    };
  },
  watch: {},
  computed: {},
  async created() {
    // this.isAdd = this.$route.query.type == "add" || this.$route.query.type == "edit" ? true : false;
    this.getInitData();
    if (this.$route.query.type == "add") {
      this.isAdd = true
    }
    if (this.$route.query.type == "view") {
      this.isAdd = false
      this.showEditBtn = false
    }
    if (this.$route.query.type == "edit") {
      this.isAdd = false
      this.showEditBtn = true
    }
    if (this.$route.query.type == "view" || this.$route.query.type == "edit") {
      await this.getSynergyDetail(this.$route.query.id);
      this.selectToTeam()
      this.selectToDoctor()
      this.getPatientList()
      this.selectFromDoctor()
    }
  },
  mounted() {},
  methods: {
    beforeRemovePic() {

    },
    handleIntroChange(response) {
      let url;
      if (response.code == 0) {
        url = this.imgPath + response.data;
        return this.baseForm.patientMedicalDocs.push(url)
      }
    },
    // 获取会诊状态枚举
    async getSynergyStatus() {
      let res = await synergyStatus()
      if (res.code == 0) {
        this.synergyStatusList = res.data
      }
    },
    async getInitData() {
      let res = await fromOrgs();
      if (res.code == 0) {
        this.fromOrgsList = res.data;
      }
    },
    // 获取机构下的医生
    async selectFromDoctor(val) {
      if (val) {
        this.baseForm.fromDoctorId = ''
        this.baseForm.fromDoctorIndex = null

        // 切换清空数据
        this.baseForm.admissionDoctorId = '' 
        this.baseForm.admissionDoctorTeamId = ''
        this.baseForm.patientId = ''
        this.baseForm.admissionHospitalName = ''

        this.toTeamsList = []
        this.toDoctorsList = []
        this.patientList = []
      }
      let res = await fromDoctors({
        fromOrgId: this.baseForm.fromHospitalId
      })
      if (res.code == 0) {
        this.fromDoctorsList = res.data
      }
    },
    getAdmissionList(val) {
      // let filterFromDoctor = this.fromDoctorsList.filter(v => v.fromDoctorId == val)[0]
      let filterFromDoctor = this.fromDoctorsList[val]
      this.baseForm.fromDoctorId = filterFromDoctor.fromDoctorId
      this.baseForm.fromDoctorTeamName = filterFromDoctor.fromTeamName
      this.baseForm.fromDoctorTeamId = filterFromDoctor.fromTeamId
      
      // 切换清空数据
      this.baseForm.admissionDoctorId = '' 
      this.baseForm.admissionDoctorTeamId = ''
      this.baseForm.patientId = ''
      this.baseForm.admissionHospitalName = ''

      this.toTeamsList = []
      this.toDoctorsList = []
      this.patientList = []
      this.selectToTeam()
      this.selectToDoctor()
      this.getPatientList()
      this.getComputedPrice()
    },
    changeToDoctors(val) {
      this.baseForm.admissionHospitalName = this.toDoctorsList.filter(v => v.toDoctorId == val)[0].orgName
      this.getComputedPrice()
    },
    changeToTeams(val) {
      this.baseForm.admissionHospitalName = this.toTeamsList.filter(v => v.toTeamId == val)[0].orgName
      this.getComputedPrice()
    },
    // 获取参与团队
    async selectToTeam() {
      let res = await toTeams({
        fromDoctorId: this.baseForm.fromDoctorId
      })
      if (res.code == 0) {
        this.toTeamsList = res.data
      }
    },
    // 获取参与医生
    async selectToDoctor() {
      let res = await toDoctors({
        fromDoctorId: this.baseForm.fromDoctorId
      })
      if (res.code == 0) {
        this.toDoctorsList = res.data
      }
    },
    // 获取患者列表
    async getPatientList() {
      let res = await relationPatients({
        fromDoctorId: this.baseForm.fromDoctorId,
        fromDoctorTeamIds: [this.baseForm.fromDoctorTeamId]
      })
      if (res.code == 0) {
        this.patientList = res.data
      }
    },
    changeAdmissionType(val) {
      if (val == 'single' && this.baseForm.admissionDoctorId || val == 'team' && this.baseForm.admissionDoctorTeamId) {
        this.getComputedPrice()
      }
      // this.baseForm.admissionHospitalName = ''
    },
    changePatient() {
      // this.getComputedPrice()
    },
    // 获取默认价格 (数据拿到调接口)
    async getComputedPrice() {
      if (this.baseForm.type && this.baseForm.fromDoctorId && (this.baseForm.admissionDoctorId || this.baseForm.admissionDoctorTeamId)) {
        let res = await computedPrice({
          type: this.baseForm.type,
          fromDoctorId: this.baseForm.fromDoctorId,
          admissionType: this.baseForm.admissionType,
          admissionDoctorId: this.baseForm.admissionDoctorId,
          admissionDoctorTeamId: this.baseForm.admissionDoctorTeamId
        })
        if (res.code == 0) {
          this.baseForm.synergyPrice = res.data
        }
      }
    },
    // 取消
    handleCancel() {
      this.$router.push({
        path: "/cooperateWithManage/consultationCooperate"
      });
    },
    changePrice() {
      this.editPrice = !this.editPrice
    },
    // async beforeAvatarUpload(file) {
    //   return new Promise(async (resolve, reject) => {
    //     const isJPG = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg'
    //     // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
    //     const isLt10M = file.size / 1024 / 1024 < 50
    //     if (!isJPG) {
    //       this.$message.error('上传图片只能是 jpg/png/jpeg 格式!')
    //       return reject();
    //     }
    //     if (!isLt10M) {
    //       this.$message.error('上传图片大小不能超过 50MB!')
    //       return reject();
    //     }
    //     resolve();
    //   });
    // },
    // async handleAvatarSuccess(res, file) {
    //   this.baseForm.patientMedicalDocs.push(this.imgPath + res.data)
    // },
    // index
    delMedicalImg(index) {
      this.baseForm.patientMedicalDocs.splice(index,1)
    },
    handleFold() {
      this.showStatus = !this.showStatus
    },
    toQuoteEntry() {
      this.showLookPic = true
    },
    getQuoteData(urls) {
      console.log(urls)
      this.baseForm.patientMedicalDocs.push(...urls)
    },
    resetBasicForm() {
      if(this.isAdd) {
        this.$refs.basicForm.resetFields();
      }
      if(this.isEdit) {
        this.baseForm.title = ''
        this.baseForm.startTime = ''
        this.baseForm.fromDoctorReqList = []
        this.baseForm.patientChiefComplaint = ''
        this.baseForm.patientDiseaseDesc = ''
        this.baseForm.patientMedicalDocs = []
      }
      // if(this.isEdit && this.baseForm.status == 'unpay') {
      //   this.baseForm.synergyPrice = null
      // }
    },
    editBasicForm() {
      this.isEdit = true;
      this.showEditBtn = false
    },
    // 查看判断可编辑项有status
    async getSynergyDetail(id) {
      let res = await synergyDetail(id);
      if (res.code == 0) {
        this.baseForm = res.data;
        this.baseForm.patientMedicalDocs = this.baseForm.patientMedicalDocs ? this.baseForm.patientMedicalDocs : []
        // this.baseForm.fromDoctorReqList = this.baseForm.fromDoctorReq.split(',')
        this.$set(this.baseForm,'fromDoctorReqList',this.baseForm.fromDoctorReq ? this.baseForm.fromDoctorReq.split(',') : [])
        // this.baseForm.patientMedicalDocs = []
      }
    },
    async saveBasicForm() {
      if (this.baseForm.synergyPrice && Number(this.baseForm.synergyPrice) > 9999.99) {
        this.$message.error('协同价格最大9999.99，请修改')
        return
      }
      let valRes;
      this.$refs.basicForm.validate((val) => {
        valRes = val;
      });
      if (!valRes) {
        return false;
      }
      if (new Date(this.baseForm.startTime).getTime() <= Date.now()) {
        this.$message.error('协同时间应大于当前时间')
        return
      }
      if (this.isAdd && (new Date(this.baseForm.startTime).getTime() < Date.now() + 4*60*60*1000)) {
        this.$message.error('仅可选择当前进入时间4h后的时间')
        return
      }
       
      // console.log(this.baseForm);
      this.baseForm.fromDoctorReq = this.baseForm.fromDoctorReqList.join(',')
      this.baseForm.startTime = this.baseForm.startTime.length == 16 ? this.baseForm.startTime + ':00' : this.baseForm.startTime
      if (this.baseForm.admissionType == 'single') {
        this.baseForm.admissionDoctorTeamId = ''
      }
      if (this.baseForm.admissionType == 'team') {
        this.baseForm.admissionDoctorId = ''
      }
      if (this.baseForm.synergyId) {
        // 修改
        let res = await updateSynergy({
          ...this.baseForm
        });
        if (res.code == 0) {
          this.$message.success("修改成功");
          this.$router.push({
            path: "/cooperateWithManage/consultationCooperate"
          });
        }
      } else {
        // 新增
        let res = await createSynergy({
          ...this.baseForm
        });
        if (res.code == 0) {
          this.$message.success("添加成功");
          this.$router.push({
            path: "/cooperateWithManage/consultationCooperate"
          });
        }
      }
    },
  },
};
</script>
<style lang="less">
.create-synergy-info .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
<style lang="less" scoped>
.patient-info {
  background: #FAFAFA;
  padding: 15px 0;
  width: 1000px;
  // height: 230px;
  margin-bottom: 20px;
  padding-bottom: 1px;
}
.img-list {
  display: flex;
  flex-wrap: wrap;
  // margin-top: 30px;
  li {
    position: relative;
    margin-right: 20px;
    margin-top: 18px;
  }
  .el-image {
    width: 80px;
    height: 80px;
    border-radius: 8px;
  }
  .del-img-btn {
    width: 20px;
    height: 20px;
    background: #999999;
    border-radius: 50%;
    color: #FFFFFF;
    position: absolute;
    top: -10px;
    right: -10px;
    line-height:20px;
    text-align: center;
  }
}
.upload-form-item {
  /deep/.el-form-item__content {
    line-height: unset;
  }
}
.create-synergy-info {
  height: 100%;
}
/deep/.el-select {
  width: 100%;
}
.header-info {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  p {
    width: 4px;
    height: 15px;
    background: #1a7bfc;
    margin-right: 12px;
  }
  h1,
  .disease-record {
    font-size: 14px;
    font-weight: bolder;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
  }
}
.header {
  background: #fff;

  .text {
    padding: 24px;
    color: #333333;
    font-size: 14px;
    line-height: 22px;
    padding-bottom: 20px;
    // border-bottom: 16px solid #F8F8F8;
    display: flex;
    align-items: center;
    span:nth-child(2) {
      color: #333;
      flex: 1;
    }

    span:nth-child(1) {
      color: #999;
    }
  }
}
.content {
  background: #fff;
  margin: 20px;
  padding: 34px;
  height: calc(100% - 90px);
  .box-item {
    padding: 0 16px;
    display: flex;
    span {
      flex: 1;
    }
  }
}
/deep/.el-textarea .el-input__count {
  line-height: 20px;
}
.save-price-btn {
  position: absolute;
  bottom: 0;
  right: -42px;
}
.fold-btn {
  font-size: 14px;
  color: #1A7BFC;
  position: absolute;
  bottom: 0;
  right: -54px;
  cursor: pointer;
}
</style>